import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import ExpandingTextArea from 'components/form/textarea'
import { validate } from 'email-validator'
import withFieldError from 'components/form/with-error'
import { validateRequired } from '../../../'
import './send-email.css'

// Validation functions
export const email = value =>
  validate(value) ? undefined : 'Invalid email address'

export const EmailAddress = ({ input, meta: { touched, error } }) => (
  <input
    {...input}
    className={'form-control ' + (error && touched ? 'has-error' : '')}
    type='email'
    placeholder='Email address'
  />
)

EmailAddress.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const EmailAddressWithError = withFieldError(EmailAddress)

export const EmailSubject = ({ input, meta: { touched, error } }) => (
  <input
    {...input}
    className={'form-control ' + (error && touched ? 'has-error' : '')}
    placeholder='Email subject'
  />
)

EmailSubject.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const EmailSubjectWithError = withFieldError(EmailSubject)

export const EmailBody = ({ input, meta: { touched, error } }) => (
  <ExpandingTextArea
    className={'form-control ' + (error && touched ? 'has-error' : '')}
    placeholder='What would you like to say?'
    {...input}
  />
)

EmailBody.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const EmailBodyWithError = withFieldError(EmailBody)

const SendEmailFields = ({ name }) => (
  <div className='br-send-email row'>
    <div className='col-sm-6 br-send-email-address'>
      <Field
        name={`${name}.address`}
        component={EmailAddressWithError}
        validate={[validateRequired, email]}
      />
    </div>
    <div className='col-sm-6 br-no-pad-left'>
      <Field
        name={`${name}.subject`}
        validate={validateRequired}
        component={EmailSubjectWithError}
      />
    </div>
    <div className='col-sm-12'>
      <Field
        name={`${name}.message`}
        validate={validateRequired}
        component={EmailBodyWithError}
      />
    </div>
  </div>
)

SendEmailFields.propTypes = {
  name: PropTypes.string
}

export default SendEmailFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-email/index.js